import {
    CURRENCY_REQUEST,
    CURRENCY_SUCCESS,
    CURRENCY_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const CurrencyAction = (data) => {
    return function (dispatch) {
    return new Promise((resolve, reject) => {

      dispatch({
        type: CURRENCY_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_candidate_price`,
        method: "POST",
        data:data,
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(AddCurrencyPre(res.data));
          resolve(res.data);
       
        })
        .catch((error) => {
          dispatch({
            type: CURRENCY_FAIL,
            payload: false,
            error: error,
            createJob: error.success,
            msg: "Failed to create",
          });
          toast.error(error.response.data.status.message)
        //   toast.error(error.msg);
        reject(error);

        });
        });
    };
  };
  
  export const AddCurrencyPre = (data) => {
    toast.success("Updated Successfully!");

    // setTimeout(()=>{
    //     // window.location.href = "/candidate_dashboard";
    //     navigate('/candidate_dashboard')
    //   },1500)
    return {
      type: CURRENCY_SUCCESS,
      result: data,
      payload: false,
      msg: data.status.message,
    };
  };